import { Component, OnInit } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { BiometricService } from "src/app/services/biometric/biometric.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CustomerModel } from "src/app/models/customer-model";
import { App } from "@capacitor/app";

@Component({
  selector: "app-account-information",
  templateUrl: "./account-information.component.html",
  styleUrls: ["./account-information.component.scss"],
})

export class AccountInformationComponent implements OnInit {

  public advertisingID: string;
  public appName: string;
  public clientApp: string;
  public councilLink: string;
  public councilLinkName: string;
  public councilLinkText: string;
  public customer: CustomerModel;
  public deviceId: string;
  public env: string;
  public isIOSApp: boolean = false;
  public isMobileApp: boolean;
  public isTestAccount: boolean = false;
  public joinDate: any;
  public lastIPAddress: any;
  public lastLoginTime: any;
  public lastLogoutReason: any;
  public packageName: string;

  public selfExclusionPage: string;
  public touchIDLabel: string = "Touch/Face ID";
  public useTouchID: boolean = false;
  public versionCode: string | number;
  public versionNumber: string;

  constructor(
    public appLinks: AppLinksService,
    public biometricService:  BiometricService,
    public config: ConfigService,
    public navigator: Navigator,
    public platform: Platform,
    public storage: Storage,
    public userSession: UserSessionService,
    public utils: UtilsService,
  ){
    this.getCustomer();
  }

  private getCustomer() {
    this.userSession.getCustomer().subscribe({
      next: (customer) => {
        if (customer) {
          this.customer = customer;
          if (customer.lastLoginTime) {
            this.lastLoginTime = customer.lastLoginTime;
          }
          if (customer.createdDate) {
            this.joinDate = customer.createdDate;
          }
          this.isTestAccount = this.customer.testAccount;
        }
      },
      error: (err) => {
        console.error("getCustomer", err);
      }
    });
  }

  async ngOnInit() {
    const appConfigInfo = this.config.getConfig();
    this.councilLink = appConfigInfo.COUNCIL_LINK;
    this.councilLinkName = appConfigInfo.COUNCIL_LINK_NAME;
    this.councilLinkText = appConfigInfo.COUNCIL_LINK_TEXT;
    this.selfExclusionPage = appConfigInfo.self_exclusion_page;

    // do not display IP details
    this.lastIPAddress = localStorage.getItem('lastIPAddress');
    const lastLogoutReason = localStorage.getItem('lastLogoutReason');

    if (lastLogoutReason == "GAME_CLT_LOGOUT" || lastLogoutReason == "APP_INACTIVITY") {
      this.lastLogoutReason = lastLogoutReason;
    }

    this.versionNumber = "N/A";

    this.clientApp = this.config.getClientApp();

    if (this.platform.is("capacitor")) {
      this.isMobileApp = true;
      const info = await App.getInfo()
      this.versionNumber = info.version;

      this.env = this.config.getEnv().env;

      if (this.platform.is("ios")) {
        this.isIOSApp = true;
      }
    } else {
      this.isMobileApp = false;
    }
  }

  openPage(page) {
    this.navigator.navigateTo(page, { multipleModals: true });
    return false;
  }

  clearTouchID() {
    this.biometricService.deleteCredentials();
    this.useTouchID = false;
  }

  goToCouncilLink() {
    this.appLinks.openExternalPage(this.councilLink);
    return false;
  }
}
